import {
  Modal,
  Paper,
  styled,
  Box,
  Typography,
  Button,
} from '@material-ui/core';
import React from 'react';

const StyledPaper = styled(Paper)({
  width: 560,
  position: 'absolute',
  margin: 'auto',
  padding: '24px',
  borderRadius: 6,
  display: 'flex',
  flexDirection: 'column',
  gap: 24,
  boxSizing: 'border-box',
  boxShadow: '0px 12px 16px 0px rgba(0, 0, 0, 0.58)',
});

const StyledTitle = styled(Typography)({
  fontSize: 20,
  letterSpacing: 0.15,
  fontFamily: 'Red Hat Display, sans-serif',
  color: '#092241',
  margin: 0,
});

const StyledContent = styled(Typography)({
  fontFamily: 'Open Sans, sans-serif',
  color: 'rgba(9, 34, 65, 0.7)',
  letterSpacing: 0.44,
  margin: 0,
});

interface ConfirmProps {
  isOpen: boolean;
  title: string;
  content: string;
  onConfirm?: () => void;
  onClose: () => void;
  confirm?: string;
  cancel?: string;
}

export const Confirm = ({
  isOpen,
  title,
  content,
  onConfirm,
  onClose,
  confirm,
  cancel,
}: ConfirmProps) => {
  return (
    <Modal
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1301,
      }}
      open={isOpen}
      onClose={onClose}
    >
      <StyledPaper elevation={0}>
        <StyledTitle variant="h6" gutterBottom>
          {title}
        </StyledTitle>
        <StyledContent variant="body1" gutterBottom>
          {content}
        </StyledContent>
        <Box display="flex" justifyContent="flex-end" gridColumnGap={16}>
          <Button onClick={onClose} color="primary" variant="text">
            {cancel}
          </Button>
          {confirm && (
            <Button onClick={onConfirm} variant="text" color="primary">
              {confirm}
            </Button>
          )}
        </Box>
      </StyledPaper>
    </Modal>
  );
};
